import $ from 'jquery';
import Backbone from 'backbone';
import { T_ } from '@shared/translation';
import { getCSRFToken } from '@shared/cookie';
import { getURLParameter } from '@shared/url';

export default Backbone.Model.extend({
  validate(attrs) {
    let isValid = true;
    if (!attrs.username) {
      const msg = T_('Please enter your username or email');
      this.trigger('username:invalid', msg);
      isValid = false;
    } else {
      this.trigger('username:valid');
    }
    if (!attrs.password) {
      const msg1 = T_('Please enter your password');
      this.trigger('password:invalid', msg1);
      isValid = false;
    }
    if (!isValid) {
      this.trigger('error', 'none');
      return false;
    }

    this.trigger('password:valid');
    return true;
  },

  login() {
    // Validate the model
    if (!this.validate({
      username: this.get('username'),
      password: this.get('password'),
    })) {
      return false;
    }

    // Do login
    $.ajax({
      url: '/users/ajaxonlogin.php',
      context: this,
      type: 'POST',
      cache: false,
      data: {
        username: this.get('username'),
        passwd: this.get('password'),
        savelogin: this.get('save_login') ? 'on' : 'off',
        goto_url: this.get('goto_url'),
        csrf_token: getCSRFToken(),
        token: getURLParameter('k'),
      },
      dataType: 'JSON',
      success: this.onSuccess,
      error: this.onError,
    });
  },

  onSuccess(resp) {
    if (resp.status == 'success') {
      if (resp.suspended) {
        this.trigger('suspended', resp.goto_url);
      } else if (resp.goto_url) {
        this.trigger('redirection', resp.goto_url);
      } else {
        this.trigger('success');
      }
    } else if (resp.status === 'error') {
      if (resp.goto_url) {
        this.trigger('redirection', resp.goto_url);
      }
    }
  },

  onError(data) {
    const result = data.responseJSON.result;
    const msg = result.description;

    if (result.extra && result.extra.goto_url) {
      this.trigger('redirection', result.extra.goto_url);
    } else if (result.extra && result.extra.warning) {
      this.trigger('warning', msg);
    } else {
      this.trigger('error', msg);
    }
  },
});
